window.require = function (module) {
  console.warn(`require('${module}') appelé mais n'est pas supporté en ESM. Vérifiez vos imports.`);
  return {}; // Retourne un objet vide pour éviter les erreurs
};

import React from "react";
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ROUTES } from "./routes/Routes";
import { StoreProvider } from "./context/StoreProvider";
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import { PopupProvider } from './context/PopupContext';
import AutoPopup from './components/Common/Popup/AutoPopup';
import { currentTheme } from "./utils/theme.utils";
import 'normalize.css';
import './global.css'
import 'react-toastify/dist/ReactToastify.css';
import './tailwind.css'
// Create a client, with base url for all requests
const queryClient = new QueryClient({
  defaultOptions: {
    baseQuery: {
      baseURL: process.env.API_URL_LOCAL,
    },
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const router = createBrowserRouter(ROUTES);

const initializeTheme = () => {
  const theme = currentTheme() || 'light'
  if (!currentTheme()) {
    localStorage.setItem('theme', theme)
  }
  document.documentElement.setAttribute('data-theme', theme)
}

initializeTheme()

ReactDOM.createRoot(document.getElementById("root")).render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <StoreProvider>
        <PopupProvider>
          <ToastContainer />
          <RouterProvider router={router} />
          <AutoPopup />
        </PopupProvider>
      </StoreProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </HelmetProvider>
);
